import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-assigned-inspections',
    templateUrl: './assigned-inspections.component.html',
    styleUrls: ['./assigned-inspections.component.css'],
    standalone: false
})
export class AssignedInspectionsViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
